a {
    font-weight: var(--anchor-font-weight);
    text-decoration: var(--anchor-default-text-decoration);
    color: var(--anchor-default-font-color);
    outline: 0;

    &:hover {
        text-decoration: var(--anchor-active-text-decoration);
        color: var(--anchor-hover-font-color);
    }

    &:active {
        text-decoration: var(--anchor-active-text-decoration);
        color: var(--anchor-active-font-color);
    }

    &:visited {
        color: var(--anchor-visited-font-color);
    }

    &:focus-visible {
        outline: var(--focus-outline);
        outline-offset: var(--focus-outline-offset);
    }
}